var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areaRank"},[_vm._v(" areaRank ")])
}
var staticRenderFns = []

export { render, staticRenderFns }